var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"no-user-image",style:({ height: _vm.height, width: _vm.width })},[_c('span',{style:({ fontSize: _vm.fontSize + 'px' }),attrs:{"title":(_vm.firstName + " " + _vm.lastName)}},[_vm._v("\n            "+_vm._s(_vm.firstName.charAt(0))+_vm._s(_vm.lastName.charAt(0))+"\n    ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9eab0dd0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/errors/NoUserImage.vue
// module id = null
// module chunks = 